import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  n: '01',
  title: 'Entendemos',
  desc: 'Mapeamos cómo funciona hoy tu proceso.'
}, {
  n: '02',
  title: 'Diseñamos',
  desc: 'Definimos la arquitectura y los flujos que deben conectarse.'
}, {
  n: '03',
  title: 'Construimos',
  desc: 'Implementamos presencia digital, automatizaciones, CRM e IA.'
}, {
  n: '04',
  title: 'Evolucionamos',
  desc: 'Medimos y ajustamos el sistema según tu empresa.'
}];
export function HowWeBuild() {
  return <section className="bg-arena py-[60px] md:py-[92px]" data-id="element-106" data-mp="2jirjm0cw1td4">
      <div className="max-w-[1100px] mx-auto px-6 md:px-20" data-id="element-107" data-mp="2y8p3w57p5yx1">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-8 md:mb-10 text-center max-w-[560px] mx-auto" data-id="element-108" data-mp="2tani3civzlhv">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-[0.15em] mb-4" data-id="element-109" data-mp="3grezl0q0xpo9">
            CÓMO TRABAJAMOS
          </span>
          <h2 className="font-display text-[28px] md:text-[38px] font-medium text-carbon leading-[1.15]" data-id="element-110" data-mp="3ktin4npywkpw">
            Primero entendemos. Después construimos.
          </h2>
        </motion.div>

        <div className="relative grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-5" data-id="element-111" data-mp="3urzli5r8k1lz">
          {/* connecting line, desktop only */}
          <div aria-hidden="true" className="hidden md:block absolute top-[13px] left-[6%] right-[6%] h-px bg-carbon/10" data-id="element-112" data-mp="3j2gejyjn3h6" />

          {steps.map((step, idx) => <motion.div key={step.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.35,
          ease: 'easeOut',
          delay: idx * 0.08
        }} className="relative" data-id="element-113" data-mp="cfjheud71kz7" data-mpi={idx}>
              <div className="flex items-center gap-3 mb-3" data-id="element-114" data-mp="1k7v0l392j8k">
                <span className="relative z-10 flex items-center justify-center w-7 h-7 bg-verde text-arena font-display text-[11px] font-medium flex-shrink-0" data-id="element-115" data-mp="3stoh9ldrq1qc">
                  {idx + 1}
                </span>
                <span className="font-body text-[11px] text-carbon/30 tracking-[0.1em]" data-id="element-116" data-mp="6ju7gsb97vgb">
                  {step.n}
                </span>
              </div>
              <h3 className="font-display text-[17px] font-medium text-carbon mb-1.5" data-id="element-117" data-mp="fe8k0n4egrvq">
                {step.title}
              </h3>
              <p className="font-body text-[13.5px] text-carbon/60 leading-[1.6]" data-id="element-118" data-mp="u9ol3c3edo1m">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}